import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.hwhctherapy.com";

interface PageSEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: "website" | "article";
  ogImage?: string;
  noindex?: boolean;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export const PageSEO = ({
  title,
  description,
  canonical,
  ogTitle,
  ogDescription,
  ogType = "website",
  ogImage,
  noindex = false,
  jsonLd,
}: PageSEOProps) => {
  const location = useLocation();
  const canonicalUrl = canonical ?? `${BASE_URL}${location.pathname}`;
  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  const absoluteOgImage = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${BASE_URL}${ogImage.startsWith("/") ? "" : "/"}${ogImage}`
    : undefined;

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonicalUrl} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      <meta property="og:type" content={ogType} />
      {ogTitle ? <meta property="og:title" content={ogTitle} /> : null}
      {ogDescription ? (
        <meta property="og:description" content={ogDescription} />
      ) : null}
      <meta property="og:url" content={canonicalUrl} />
      {absoluteOgImage ? <meta property="og:image" content={absoluteOgImage} /> : null}
      {absoluteOgImage ? <meta name="twitter:image" content={absoluteOgImage} /> : null}
      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};
